import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CompanyFormComponent } from 'src/app/shared/components/forms/company-form/company-form.component';
import { AutomakerDto, AutomakerNoIdDto } from 'src/app/shared/models/automaker/automaker-dto';
import { StateDto } from 'src/app/shared/models/location/state-dto';
import { ProductLineDto } from 'src/app/shared/models/product-line/product-line-dto';

@Component({
    selector: 'app-automaker-form',
    templateUrl: './automaker-form.component.html',
    standalone: false
})
export class AutomakerFormComponent implements OnInit {
  loading = false;
  form: FormGroup = null;

  @Input() readonly: boolean = false;
  @Input() states: StateDto[] = [];
  @Input() productLines: ProductLineDto[] = [];

  @ViewChild(CompanyFormComponent) companyForm: CompanyFormComponent;

  constructor(public readonly builder: FormBuilder) {
    this.form = this.builder.group({
      code: ['', Validators.required],
      productLine: ['', Validators.required],
      active: [true],
      // deleted: [false],
      orderCancellationMichelin: [false],
      orderCancellationDistributor: [false],
      orderCancellationAutomaker: [false],
      commissionPercentage: [null, [Validators.min(0), Validators.max(100)]]
      /** O componente <app-company-form/> vai adicionar o formGroup company */
    });
  }

  get productLine(): FormControl {
    return this.form.get('productLine') as FormControl;
  }

  get formValues(): AutomakerNoIdDto {
    return {
      code: this.form.value.code,
      status: this.form.value.active ? 'A' : 'I',
      // deleted: this.form.value.deleted,
      productLineId: this.form.value.productLine?.id,
      company: this.companyForm?.formValues,
      orderCancellationMichelin: this.form.value.orderCancellationMichelin,
      orderCancellationDistributor: this.form.value.orderCancellationDistributor,
      orderCancellationAutomaker: this.form.value.orderCancellationAutomaker,
      commissionPercentage: this.form.value.commissionPercentage
    };
  }

  loadFormValues(data: AutomakerDto) {
    this.form.patchValue({
      code: data.code,
      active: data.status == 'A' ? true : false,
      // deleted: data.deleted,
      productLine: data.productLine,
      orderCancellationMichelin: data.orderCancellationMichelin,
      orderCancellationDistributor: data.orderCancellationDistributor,
      orderCancellationAutomaker: data.orderCancellationAutomaker,
      commissionPercentage: data.commissionPercentage
    });
    this.companyForm.loadFormValues(data.company);
  }

  codeDisplayName(data: any) {
    return data?.code || '';
  }

  ngOnInit() {
    if (this.readonly) {
      this.form.disable();
    }
  }
}
